export default __webpack_public_path__ + "static/media/projector-screen-chart.0e3fb483.svg";